import Api from '../Api'

import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_USER_SESSION,
  RECEIVE_USER_SESSION,
  CHECK_USER_SESSION,
  REMOVE_USER_SESSION,
  RECEIVE_USER_REQUEST_INFO,
  REGISTER_USER,
  VERIFY_USER_EMAIL,
  REQUEST_USER_DATA,
  RECEIVE_USER_DATA
} from '../actions/user-session'

const errorHandler = (action_payload) => {
  const { data } = action_payload

  if (data.status === 'error') {
    return {
      error: {
        code: action_payload.status,
        message: data.message
      }
    }
  }
}

export default handleActions({
  [REQUEST_USER_SESSION]: (state, action) => {
    return update(state, {
      $merge: {
        isLoggingIn: true,
        loggedIn: false,
        loginToken: null,
        user: undefined,
        registrationRequest: undefined,
        registration: undefined,
        verification: undefined
      }
    })
  },
  [RECEIVE_USER_SESSION]: (state, action) => {
    const { token } = action.payload.data

    return update(state, {
      $merge: {
        isLoggingIn: false,
        loggedIn: !!token,
        loginToken: token
      }
    })
  },
  [CHECK_USER_SESSION]: (state, action) => {
    const { token } = action.payload.data

    return update(state, {
      $merge: {
        loggedIn: !!token,
        loginToken: token
      }
    })
  },
  [REMOVE_USER_SESSION]: (state, action) => {
    return update(state, {
      $merge: {
        loggedIn: false,
        loginToken: null,
        user: undefined
      }
    })
  },
  [RECEIVE_USER_REQUEST_INFO]: (state, action) => {
    const error = errorHandler(action.payload)
    if (error) return error

    const { email, code } = action.payload.data

    return update(state, {
      $merge: {
        registrationRequest: {
          email,
          code
        }
      }
    })
  },
  [REGISTER_USER]: (state, action) => {
    const { token, user, userstatus } = action.payload.data

    state = update(state, {
      $merge: {
        loggedIn: userstatus === 'active' ? !!token : false,
        loginToken: userstatus === 'active' ? token : null,
        user: undefined,
        registration: {
          email: (user && user.email)
        }
      }
    })

    if (state.registrationRequest && (state.registrationRequest.email !== user.email)) {
      state = update(state, {
        $merge: {
          verification: {
            required: true
          }
        }
      })
    }

    return state
  },
  [VERIFY_USER_EMAIL]: (state, action) => {
    const error = errorHandler(action.payload)
    if (error) return error

    const { token, user } = action.payload.data

    return update(state, {
      $merge: {
        loggedIn: !!token,
        loginToken: token,
        user: undefined,
        verification: {
          email: (user && user.email)
        }
      }
    })
  },
  [REQUEST_USER_DATA]: (state, action) => {
    return update(state, {
      $merge: {
        user: {
          isFetching: true
        }
      }
    })
  },
  [RECEIVE_USER_DATA]: (state, action) => {
    const { user } = action.payload.data

    return update(state, {
      $merge: {
        user
      }
    })
  }
},
{
  loggedIn: undefined,
  loginToken: undefined
})



// WEBPACK FOOTER //
// ./src/reducers/user-session.js